module.exports = __webpack_public_path__ + "img/testImage12.be3903a4.be3903a4.png";